import Vue from 'vue'
import Vuex from 'vuex'
import '@/assets/js/api'

Vue.use(Vuex)


//* State
export const state = () => ({

  locationRenew: {
    area:"美濃",
    path:'/',
    number: 0,
    name: "美濃",
    inf: "美麗的南方客家小鎮—美濃，隸屬臺灣「客家六堆」中的右堆，以豐富的客家文化風情聞名，好山好水與傳統的客庄文化共同孕育出在地特有的人文地景。漫步於古老的永安老街，沿途的歷史古蹟如美濃舊橋、東門樓、敬字亭及隨處可見的古樸菸樓，為旅客展現了客庄悠久的歷史與產業。走一趟美濃，用獨特的慢遊節奏，實際體驗客庄生活，深刻感受客家山城的獨特魅力！",
    mainimg:"location1/p1-1-1.jpg",
    imgList: {
      items: [
        {
          id:11101,
          img: "location1/p1-1-1.jpg"
        },
      ]
    },
    iframemap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3675.154260062858!2d120.5533757!3d22.907680399999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346e422087738e51%3A0x6768d416f894b0f0!2z576O5r-D5rmW!5e0!3m2!1szh-TW!2stw!4v1715678758337!5m2!1szh-TW!2stw",
  },
});



export const mutations = {
  // 
  SET_location(state, payload) {
    state.locationRenew = payload;
  },


};


export default new Vuex.Store({
  state,
  mutations,
})
